
const ERRORS = {
  NoTender: 'Deze aanbesteding bestaat niet meer.',
  NoDocuments: 'Deze aanbesteding heeft geen documenten, dus we kunnen geen samenvatting maken.',
  NoPrimaryDocument: 'We hebben geen hoofddocument kunnen vinden.',
  InvalidTenderVersionId: 'Het hoofddocument van deze aanbesteding is niet meer beschikbaar.',
  SummaryExtractionFailed: 'We konden geen samenvatting maken.',
  SummaryExtractionBlobNull: 'We konden geen samenvatting maken.',
  ConfidenceBelowThreshold: 'We waren niet zeker genoeg van de samenvatting om deze te tonen.',
  DocumentTypeNotSupported: 'Op dit moment ondersteunen we alleen PDF documenten als hoofddocument.'
};
export default {
  props: {
    active: {
      type: Boolean
    },
    tenderId: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      summary: null
    };
  },

  fetchOnServer: false,

  async fetch () {
    this.summary = await this.$axios.$get(`/summaryextraction/${this.tenderId}`);
  },

  computed: {
    error () {
      if (!this.$fetchState.error) { return null; }

      const error = ERRORS[this.$fetchState.error.response.data];

      if (!error) {
        return 'We konden geen samenvatting maken.';
      }

      return error;
    }
  }
};
